//订单相关
export default{
	//获取订单状态
	getOrderState: (order) => {
		if(order.State == 'NW'){
			return '应到未到'
		}
		else if(order.State == 'C0'){
			return '取消成功'
		}
		else if(order.State == 'C1'){
			return '退款失败'
		}
		else if(order.State == 'C2'){
			return '正在退款'
		}
		else if(order.State == 'R2'){
			return '交易中'
		}
		//支付宝创建支付信息但是没有支付  交易 进行中
		else if(order.State == 'R2' && order.listResvPayInfo[0] && order.listResvPayInfo[0].PayStatus =='0'){
			return '交易中1'
		} 
		else if(order.State == 'R2' && order.listResvPayInfo[0] && order.listResvPayInfo[0].PayStatus !='0'){
			return '交易中2' + order.listResvPayInfo[0].PayStatus
		}
		else if(order.State == 'R1'){
			return '交易失败'
		}
		else if(order.State == 'R999' || order.State == 'booking888'){
			return '已入住'
		}
		else if(order.State == 'R0' && order.PayStatus !='0'){
			return '预订成功'
		}
		else if(order.State == 'R0' && order.PayStatus =='0'){
			return '已支付'
		}
	},
	getOrderOption: (order) => {
		return {
			//是否展示支付
			showPay:(order.State == 'R0' && order.PayStatus !='0') ||  order.State === 'R2',
			//是否展示取消订单
			showCancel:order.State == 'R0' || order.State == 'R2',
			//是否展示删除订单
			showDelete:!(order.State == 'R0' || order.State == 'R2')
		}
	}
}


// WEBPACK FOOTER //
// ./src/utils/order.js